<div class="ProductUpdate">
    <ce-breadcrumb
        [isLoading]="pageState().isLoading"
        class="u-hide-gt-sm"
        productName="ChargeEye"
        [breadcrumbRoutes]="pageState().breadCrumbData"
    />

    <ce-template-view-header
        [heading]="pageState().entry?.title ?? ''"
        [backRouterLink]="'/help/product-updates/' + (pageState().entry?.type ?? '')"
    >
        <div view-header-slot="actions">
            <button type="button" ce-button ce-button-small ce-button-type-tertiary [ceContextMenuTriggerFor]="actions">
                Actions
                <ce-icon svgIcon="more" suffix-icon ce-icon-sm />
            </button>

            <ce-context-menu #actions>
                <ce-list size="sm">
                    <ce-list-option (click)="copyUrl()" (keydown.enter)="copyUrl()">
                        <ce-icon ce-icon-sm ce-list-option-prefix svgIcon="share" />
                        Copy URL
                    </ce-list-option>
                    @if (isSysAdmin) {
                        <ce-list-option (click)="editInAdmin()" (keydown.enter)="editInAdmin()">
                            <ce-icon ce-icon-sm ce-list-option-prefix svgIcon="draft" />
                            Edit in Contentless
                        </ce-list-option>
                    }
                </ce-list>
            </ce-context-menu>
        </div>
    </ce-template-view-header>

    @if (pageState().isLoading) {
        <div class="u-spacing-xl-mb u-spacing-xl-pa u-border-secondary u-border-radius-md u-color-background-primary" aria-busy="true" aria-label="Loading product update">
            <div class="ProductUpdate-meta flex-row flex-middle flex-between u-spacing-md-mb">
                <ce-skeleton-loader [config]="{ width: '120px', height: '16px' }" />
            </div>

            <ce-skeleton-loader [config]="{ width: '80%', height: '24px' }" class="u-spacing-lg-mb u-spacing-xs-mt" />

            <ce-skeleton-loader [config]="{ width: '100%', height: '20px' }" class="u-spacing-sm-mb" />
            <ce-skeleton-loader [config]="{ width: '95%', height: '20px' }" class="u-spacing-sm-mb" />
            <ce-skeleton-loader [config]="{ width: '60%', height: '20px' }" class="u-spacing-lg-mb" />

            <ce-skeleton-loader [config]="{ width: '35%', height: '20px' }" class="u-spacing-sm-mb u-spacing-md-mt" />
            <ce-skeleton-loader [config]="{ width: '100%', height: '20px' }" class="u-spacing-sm-mb" />
            <ce-skeleton-loader [config]="{ width: '90%', height: '20px' }" class="u-spacing-sm-mb" />
            <ce-skeleton-loader [config]="{ width: '75%', height: '20px' }" />
        </div>
    } @else if (pageState().isError || !pageState().entry) {
        <p>Could not load this product update.</p>
    } @else {
        <div class="u-spacing-xl-mb u-spacing-xl-pa u-border-secondary u-border-radius-md u-color-background-primary">

            @if (pageState().entry?.actionRequired) {
                <ce-inline-banner
                    [content]="pageState().entry?.actionText ?? ''"
                    heading="Action required"
                    state="warning"
                    class="u-spacing-lg-mb"
                />
            }

            <div class="ProductUpdate-meta flex-row flex-middle flex-between u-spacing-md-mb">
                <span class="u-text-body-xs u-color-text-secondary">
                    {{ formatDate(pageState().entry?.publishedAt ?? '') }}
                </span>
                @if (pageState().entry?.internal) {
                    <ce-pill ce-pill-xs state="info" ce-pill-secondary>Internal</ce-pill>
                }
            </div>

            <div class="ProductUpdate-content u-article" (click)="onContentClick($event)">
                @if (pageState().entry?.summary) {
                    <h2>{{ pageState().entry?.summary }}</h2>
                }
                <div [innerHTML]="pageState().entry?.detailsHtml ?? ''"></div>
            </div>
        </div>
    }

    <ce-app-product-update-light-box
        [isOpen]="lightBox().open"
        [imageSrc]="lightBox().src"
        [imageTitle]="lightBox().title"
        [imageDescription]="lightBox().description"
        (stateChange)="onLightBoxStateChange($event)"
    />
</div>
